module.exports = __webpack_public_path__ + "membership-white.svg?1cc198c260674fc2bfcea6ec321205a9";